var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
var streams = [
    {
        key: 'yurtici',
        label: 'Yurt İçi',
        description: 'TJK TV yurt içi canlı yayını YouTube üzerinden izleyebilirsiniz.',
        url: 'https://www.youtube.com/live/g89RQMJtK6E?si=AlWdjWmJQPxUeYey',
    },
    {
        key: 'yurtdisi',
        label: 'Yurt Dışı',
        description: 'TJK TV yurt dışı canlı yayını YouTube üzerinden izleyebilirsiniz.',
        url: 'https://www.youtube.com/live/ri4rR0H2i9c?si=tynYlCxBjcgho0m9',
    },
];
export function TayTv() {
    var _a = useState('yurtici'), active = _a[0], setActive = _a[1];
    var stream = streams.find(function (s) { return s.key === active; });
    return (_jsxs("div", __assign({ style: { padding: '24px 20px' } }, { children: [_jsx("div", __assign({ style: { display: 'flex', gap: 8, marginBottom: 24, justifyContent: 'center' } }, { children: streams.map(function (s) { return (_jsx("button", __assign({ onClick: function () { return setActive(s.key); }, className: 'btn ' + (active === s.key ? 'btn-default' : 'btn-outline-default'), style: { minWidth: 120 } }, { children: s.label }), s.key)); }) }), void 0), _jsxs("div", __assign({ style: { textAlign: 'center' } }, { children: [_jsxs("h3", __assign({ style: { marginBottom: 8 } }, { children: ["TJK TV \u2014 ", stream.label, " Canl\u0131 Yay\u0131n"] }), void 0), _jsx("p", __assign({ style: { color: 'var(--color-text-medium)', marginBottom: 24, fontSize: 14 } }, { children: stream.description }), void 0), _jsx("a", __assign({ href: stream.url, target: "_blank", rel: "noreferrer", className: "btn btn-danger", style: { fontSize: 15, padding: '10px 32px' } }, { children: "\u25B6 Canl\u0131 \u0130zle" }), void 0)] }), void 0)] }), void 0));
}
